module.exports = __webpack_public_path__ + "static/img/shelcal-image.a52974d.png";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/shelcal-image.png
// module id = fBvf
// module chunks = 1